import GSFNDialog, { typeOfGSFNDialog } from './GSFNDialog';
import GSFNNotFoundDialog, { typeOfGSFNNotFoundDialog } from './GSFNNotFoundDialog';

export default {
  [typeOfGSFNDialog]: GSFNDialog,
  [typeOfGSFNNotFoundDialog]: GSFNNotFoundDialog,
};
